module.exports = {"title":"Nick Doiron","talk":"If One Laptop per Child were started today, how JavaScript-y would it be?","path":"/speakers/nick-doiron","type":"speaker","slug":"nick-doiron","twitter":"mapmeld","github":"mapmeld","website":"http://mapmeld.com","companyWebsite":"http://asiafoundation.org/","company":"The Asia Foundation","body":"<p>In 2005, it looked like the future of global education might be a custom laptop and OS for $100. Today you could use that money to buy two Android tablets and access eBooks, courses, and programming tutorials on the web. An OLPC hacker reflects on teaching computing in Uganda, Uruguay, and our new JavaScript world.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/nick-doiron.md
 ** module id = 549
 ** module chunks = 0
 **/